import React, { createContext, useCallback } from 'react';
import { Redirect } from 'components';
import { assign, mapValues } from 'helpers/vendor';
import * as Fields from './fields';

export function Form({ state, setState, onSubmit, ...props }) {

  const extendState = useCallback(data => setState(state => ({
    ...state,
    ...data,
  })), []);

  const submit = event => {
    event.preventDefault();
    if (!state.pending) {
      const trimmed = mapValues(state, (value, name) => {
        if (/password/.test(name) || typeof value != 'string') {
          return value;
        }
        return value.trim();
      });
      extendState(trimmed);
      onSubmit({
        values: trimmed,
        setError: (name, message) => {
          extendState({
            [name + '_error']: message
          });
        },
        setPending: (pending = true) => {
          extendState({ pending });
        },
        setSuccess: () => {
          extendState({ success: true });
        },
        redirect: (url) => {
          extendState({ redirect: url });
        },
      })
    }
  }

  return (
    <Form.Context.Provider value={{ state, setState: extendState }}>
      <form {...props} onSubmit={submit} />
      { state.redirect && <Redirect to={state.redirect} /> }
    </Form.Context.Provider>
  );
}

assign(Form, Fields, { Context: createContext() });
